import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/styles';
import ConexaoUsuarioTable from './components/ConexaoUsuarioTable';
import ProgressFullScreen from '../../components/Compartilhados/ProgressFullScreen';
import SnackbarCustom from '../../components/Compartilhados/Snackbar';
import { NotFound as NotFoundView } from '../index';
import { isAuthenticated } from '../../helpers/authenticate';
import { Values } from '../../values/Values';
import BottomScrollListener from 'react-bottom-scroll-listener';
import { obterTodasConexoesUsuarios } from '../../services/ConexaoUsuarioService';

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(3)
  },
  content: {
    marginTop: theme.spacing(2)
  },
  pagination: {
    marginTop: theme.spacing(3),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end'
  },
  divFab:{
    zIndex: 2
  },
  fab: {
    position: 'fixed',
    bottom: theme.spacing(2),
    right: theme.spacing(2),
  },
}));
function ConexaoUsuarioList({history}) {
  const classes = useStyles();
  const [loading, setLoading] = React.useState(false);
  let [conexoesUsuarios, setConexoesUsuarios] = useState([]);
  const [showMessageSnack, setShowMessageSnack] = useState(false);
  const [messageSnack, setMessageSnack] = useState('');
  const [typeSnack, setTypeSnack] = useState('success');
  let [page, setPage] = useState(1);
  const [fimLista, setFimLista] = useState(false);

  useEffect(() => {
    function checkAuth() {
      isAuthenticated(history);
    }
    checkAuth();
  }, []);

  useEffect(() => {
    carregarConexoes();
  }, []);

  async function carregarConexoes() {
    try{
      setLoading(true);
      const dados = await obterTodasConexoesUsuarios(page, Values.limiteRegistroLista);
      if(dados.isSuccess){
        setPage(page + 1);
        let retorno = conexoesUsuarios;
        if(dados.result.length !== 0){
          for(let i = 0, size = dados.result.length; i < size; i++){
            dados.result[i].on_mouse_over = false;
            retorno.push(dados.result[i]);
          }
          setConexoesUsuarios(retorno);
        }
        else {
          if (page === 1) {
            setLoading(false);
            setTypeSnack('warning');
            setMessageSnack('Não há conexões registradas');
            setShowMessageSnack(true);
          } else {
            setFimLista(true);
          }
        }
      }
      else{
        setLoading(false);
        setTypeSnack('error');
        setMessageSnack(dados.message);
        setShowMessageSnack(true);
      }
      setLoading(false);
    }
    catch (e) {
      setLoading(false);
      setTypeSnack('error');
      setMessageSnack(Values.MessageValues.erro_catch);
      setShowMessageSnack(true);

    }
  }

  async function carregarMais() {
    if (!fimLista) {
      await carregarConexoes();
    }
  }


  return (
    <BottomScrollListener
      onBottom={e => carregarMais()}
      offset={50}
      debounce={100}
    >
      <div
        className={classes.root}
      >

        <SnackbarCustom
          verticalOrientation='bottom'
          horizontalOrientation='center'
          open={showMessageSnack}
          setOpen={setShowMessageSnack}
          message={messageSnack}
          duration={2000}
          type={typeSnack}
        />
        <div className={classes.content}>
          <ProgressFullScreen
            open={loading}
            setOpen={setLoading}
          />
          <ConexaoUsuarioTable
            conexoesUsuarios={conexoesUsuarios}
            setConexoesUsuarios={setConexoesUsuarios}
            setShowMessageSnack={setShowMessageSnack}
            setMessageSnack={setMessageSnack}
            setTypeSnack={setTypeSnack}
          />
        </div>
      </div>
    </BottomScrollListener>

  );
};

export default ConexaoUsuarioList;
